export const SSN_FETCH_STATUS_REQUEST = 'SSN_FETCH_STATUS_REQUEST';
export const SSN_FETCH_STATUS_SUCCESS = 'SSN_FETCH_STATUS_SUCCESS';
export const SSN_FETCH_STATUS_ERROR = 'SSN_FETCH_STATUS_ERROR';

export const SSN_SET_FILTER = 'SSN_SET_FILTER';
export const SSN_SET_SEARCH = 'SSN_SET_SEARCH';
export const SSN_SELECT_TARGETS = 'SSN_SELECT_TARGETS';

export const SSN_START_JOB_REQUEST = 'SSN_START_JOB_REQUEST';
export const SSN_START_JOB_SUCCESS = 'SSN_START_JOB_SUCCESS';
export const SSN_START_JOB_CONFLICT = 'SSN_START_JOB_CONFLICT';
export const SSN_START_JOB_ERROR = 'SSN_START_JOB_ERROR';

export const SSN_POLL_JOB_TICK = 'SSN_POLL_JOB_TICK';
export const SSN_JOB_TERMINAL = 'SSN_JOB_TERMINAL';
export const SSN_CLEAR_JOB = 'SSN_CLEAR_JOB';

export const SSN_REFRESH_REQUEST = 'SSN_REFRESH_REQUEST';
export const SSN_REFRESH_DONE = 'SSN_REFRESH_DONE';
